import AbstractMediator from "../../../core/ui/AbstractMediator";
import ChatInteractionEvent from "../../chat/events/ChatInteractionEvent";
import ChatModel from "../../chat/model/ChatModel";
import SmartphoneNavigateEvent from "../model/SmartphoneNavigateEvent";
import SmartphoneSoundType from "./SmartphoneSoundType";

export default class SmartphoneOpenerMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {*} target 
     * @param {*} dispatcher 
     * @param {*} soundManager 
     * @param {ChatModel} chatModel 
     */
    constructor(target, dispatcher, soundManager, chatModel) {
        super(target, dispatcher);

        this._target.startX = this._target.x;
        this._soundManager = soundManager;
        this._chatModel = chatModel;
    }

    initialize() {
        super.initialize();

        this._smartphoneButton = this.createButton(this._target, this._handleOpenerButton.bind(this), "[Smartphone]");

        this._updateUnreadItemsIndicator();

        this.registerEventListener(ChatInteractionEvent.NPC_MESSAGE_SENT, this._handleSmartphoneItemAdded.bind(this));
        this.registerEventListener(ChatInteractionEvent.CHAT_STATUS_CHANGED, this._handleSmartphoneItemOpened.bind(this));

        this.registerEventListener(SmartphoneNavigateEvent.SMARTPHONE_HIDE_REQUEST, this._handleSmartphoneClose.bind(this));
    }

    _handleOpenerButton() {
        this._stopShake();

        this._target.visible = false;

        this.dispatch(SmartphoneNavigateEvent.SMARTPHONE_SHOW_REQUEST);
    }

    _handleSmartphoneClose() {
        this._target.visible = true;
        this._updateUnreadItemsIndicator();
    }

    _handleSmartphoneItemAdded(evt) {
        this._updateUnreadItemsIndicator();
        this._startShake();
        this._soundManager.playSound(SmartphoneSoundType.NEW_CONTENT);
    }

    _handleSmartphoneItemOpened() {
        this._updateUnreadItemsIndicator();
    }

    _updateUnreadItemsIndicator() {
        const unreadCount = this._chatModel.getUnreadCount();
        if (unreadCount > 0) {
            this._target.newIndicator.visible = true;
            this._target.newIndicator.gotoAndPlay(0);
            this._target.newIndicator.newAmountTextField.text = unreadCount.toString();
        } else {
            this._target.newIndicator.visible = false;
        }
    }

    _startShake() {
        this._shakeInterval = setInterval(() => {
            this._shake();
        }, 3000);
        this._shake();
    }

    _stopShake() {
        clearInterval(this._shakeInterval);
        createjs.Tween.removeTweens(this._target);
    }

    _shake() {
        const skinToShake = this._target;
        const props = { loop: 9, bounce: true };
        createjs.Tween.get(skinToShake, props).to({ x: skinToShake.startX + 2 }, 100);
    }
}